import { Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

export interface TGSFormControl {
  name: string;
  type: string;
  title: string;
  options?: {
    value: string | number;
    text: string;
  }[];
  validators?: any[];
}

export class OverlayForm {

  @Output() save: EventEmitter<any> = new EventEmitter();
  @Output() close: EventEmitter<any> = new EventEmitter();

  form: FormGroup;
  value: any;

  constructor(
    public fb: FormBuilder
  ) {
    this.buildForm();
  }

  protected buildForm() {
  }

  onSubmit(event: Event = null) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.save.emit(this.form.value);
    this.value = this.form.value;
    this.closeOverlay();
  }

  closeOverlay(event: Event = null) {
    this.close.emit(event);
    this.value ? this.form.patchValue(this.value) : this.form.reset();
  }

  reset() {
    this.form.reset();
    this.save.emit(this.form.value);
  }

}



// WEBPACK FOOTER //
// ./src/app/models/form.ts